import styled from 'styled-components';
import { Container } from 'styled-bootstrap-grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamation } from '@fortawesome/free-solid-svg-icons/faExclamation';
import { PageHead } from '../../components/head/head';

const ErrorWrapper = styled.div`
    text-align: center;
    margin-top: 3.75rem;
`;

const ErrorTitleWrapper = styled.div`
    margin: 40px 50px;
`;

const ErrorTitleH1 = styled.h1`
    font-size: 2em;
    margin: .67em 0;
    margin-bottom: 30px;
    text-transform: uppercase;
`;

const ErrorTitleH5 = styled.h5`
    font-size: 1.25rem;
    margin-bottom: .5rem;
    font-family: inherit;
    font-weight: 500;
    line-height: 1.1;
    color: inherit;
`;

const ErrorDescriptionWrapper = styled.div`
`;

const ErrorDescriptionTitle = styled.div`
    font-weight: 700;
    padding-bottom: 10px;
`;

const ErrorDescriptionList = styled.ul`
    text-align: justify;
    display: inline-block;
`;

const ErrorDescriptionListItem = styled.li`
    padding-bottom: 5px;
`;


const ErrorIcon = styled(FontAwesomeIcon)`
    border: 3px solid ${props => props.theme.colors.text.blue};
    border-radius: 50%;
    padding: 20px 20px;
    width: 70px;
    height: 70px;
    color: ${props => props.theme.colors.text.blue};
`;

export function Unauthorized() {
    return (
        <PageHead pageTitle='You are unauthorized | {{siteName}}'>
            <ErrorWrapper>
                <Container>
                    <ErrorIcon icon={faExclamation} />
                    <ErrorTitleWrapper>
                        <ErrorTitleH1>Unauthorized: Insufficient Permissions</ErrorTitleH1>
                        <ErrorTitleH5>Sorry, but you don't have the necessary permissions to access this page.</ErrorTitleH5>
                    </ErrorTitleWrapper>
                    <ErrorDescriptionWrapper>
                        <ErrorDescriptionTitle>
                            Try one of these:
                        </ErrorDescriptionTitle>
                        <ErrorDescriptionList>
                            <ErrorDescriptionListItem>If you believe this is an error, please contact support for assistance. Thank you for your understanding.</ErrorDescriptionListItem>
                        </ErrorDescriptionList>
                    </ErrorDescriptionWrapper>
                </Container>
            </ErrorWrapper>
        </PageHead>
    )
}